import { type CriticalFailureReason } from "#src/constants/critical-failure.ts";
import { STEP } from "#src/constants/step.ts";
import {
  defineStore,
  generateInitialState,
  resetState,
  type ToSetupState,
} from "#src/stores/state-wrapper.ts";
import { type BaseStepStore } from "#src/types/StepStore.ts";
import { type Pinia, type StoreGeneric } from "pinia";
import { computed, type Ref, ref } from "vue";

interface CriticalFailureState {
  criticalFailureReason: CriticalFailureReason | null;
}
interface CriticalFailureStep
  extends BaseStepStore,
    ToSetupState<CriticalFailureState> {
  criticalFailureReason: Ref<CriticalFailureReason | null>;
}

function initialState(): CriticalFailureState {
  return {
    criticalFailureReason: null,
  };
}

function initializeCriticalFailureStep(): CriticalFailureStep {
  const state = generateInitialState<CriticalFailureState>(initialState());

  function $reset() {
    resetState<CriticalFailureState>(state, initialState());
  }

  const step = computed(() => STEP.CRITICAL_FAILURE);
  const next = computed(() => null);
  const previous = computed(() => null);
  const hidesFooter = computed(() => true);
  const controlsNext = computed(() => true);
  const hidesHeader = computed(() => true);

  return {
    $reset,
    ...state,
    step,
    next,
    previous,
    hidesFooter,
    controlsNext,
    hidesHeader,
  };
}

export const useStepCriticalFailure = (pinia: Pinia, hot?: StoreGeneric) => {
  return defineStore<string, CriticalFailureStep>(
    "step-critical-failure",
    () => {
      return initializeCriticalFailureStep();
    }
  )(pinia, hot);
};
